import jsPDF from "jspdf";
import "jspdf-autotable";



export const invoicePDF = async (id) => {

  //API Section

  try {
    debugger;
    // Fetch data from the API using the id
    const response = await fetch(`https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderShippingDetailsByOrderID?order_ID=${id}`); // Replace with your API URL
    const responseProduct = await fetch(`https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderProductDetailsByOrderID?order_ID=${id}`); // Replace with your API URL
    if (!response.ok || !responseProduct.ok) {
        throw new Error("Failed to fetch invoice data");
    }
    const data = await response.json();
    const dataProduct = await responseProduct.json();

    if (!data || !dataProduct) {
      throw new Error("Invalid response structure: orderDetails missing");
    }

    const imagePath = "/images/products/thumbnail/"; // Path relative to the public folder

    // Function to load images as Base64
    const loadImageBase64 = async (url) => {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };
    
    

    

  //API Section Ends Here

    const doc = new jsPDF();


    const logoPath = "/images/logo.png"; // Path relative to the public folder
    
    // Add Logo at the top-left
    const logoWidth = 50; // Width of the logo in the PDF
    const logoHeight = 15; // Height of the logo in the PDF
    doc.addImage(logoPath, "PNG", 10, 10, logoWidth, logoHeight); // x=10, y=10


    // Merchant Details
    doc.setFontSize(11);
    doc.text("GSTIN : 07ALHPM9734D1ZY", 10, 30);
    // Increase font size and make bold for the second row

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16); // Increase font size
    doc.text("IndiGalleria", 10, 50);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("61-B, Pink Apartments, Pocket 6/2", 10, 55);
    doc.text("Nasirpur, Sector 1A, Dwarka", 10, 60);
    doc.text("New Delhi, PIN - 110045", 10, 65);
    doc.text("Contact: +91 9555511765, 9350011765", 10, 70);
    doc.text("Email: info@indigalleria.com", 10, 75);
    doc.text("Website: www.indigalleria.com", 10, 80);


    // Convert the date to dd/MM/yyyy format
    const createdOn = new Date(data.createdOn);
    const formattedDate = createdOn.toLocaleDateString("en-GB"); // en-GB ensures dd/MM/yyyy format

    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("TAX INVOICE", 150, 20);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Invoice no : 2024-25/049", 150, 55);
    doc.text("Date : " + formattedDate, 150, 60);
    doc.text("Payment Mode : " + data.paymentMode, 150, 65);
    doc.text("Payment Status : " + data.paymentStatus, 150, 70);
    doc.text("", 150, 75);
    doc.text("Currency : " + data.currency, 150, 80);


    // Calculate the width of each box (half of the page width)
    const pageWidth = doc.internal.pageSize.getWidth();
    const boxWidth = (pageWidth - 20) / 2; // Subtract margins and divide by 2

    const billingAddress = data.billAddress + ", " + data.billArea + ", " + data.billState + ", " + data.billCountry + ", PIN/ZIP - " + data.billZIP;
    const shippingAddress = data.shipAddress + ", " + data.shipArea + ", " + data.shipState + ", " + data.shipCountry + ", PIN/ZIP - " + data.shipZIP;

    // Split the addresses into lines based on the box width
    const billingLines = doc.splitTextToSize(billingAddress, boxWidth);
    const shippingLines = doc.splitTextToSize(shippingAddress, boxWidth);
    

    //Biling Info
    doc.setFont("helvetica", "bolditalic");
    doc.text("Bill To", 10, 100);

    // Calculate text width to determine underline length
    const textWidthBill = doc.getTextWidth("Bill To");

    // Draw the underline
    doc.setLineWidth(0.5); // Set line thickness
    doc.line(10, 101, 10 + textWidthBill, 101); // x1, y1, x2, y2 (endpoints of the line)

    
    // Billing Address
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(data.billBuyerName, 10, 106);    
    billingLines.forEach((line, index) => {doc.text(line, 10, 111 + index * 4); });// Adjust Y-coordinate for each line    
    
    const nextYCoordinateBill = 111 + billingLines.length * 4;


    doc.text("GSTIN : " + data.gstin, 10, nextYCoordinateBill);
    doc.text("Contact no : " + data.billMobile, 10, nextYCoordinateBill + 4);
    doc.text("Email ID : " + data.shipEmail, 10, nextYCoordinateBill + 8);



    //Shipping Info
    doc.setFontSize(12);
    doc.setFont("helvetica", "bolditalic");
    doc.text("Ship To",  pageWidth / 2 + 10, 100);

    // Calculate text width to determine underline length
    const textWidthShip = doc.getTextWidth("Ship To");

    // Draw the underline
    doc.setLineWidth(0.5); // Set line thickness
    doc.line( pageWidth / 2 + 10, 101,  pageWidth / 2 + 10 + textWidthShip, 101); // x1, y1, x2, y2 (endpoints of the line)

    // Shipping Address
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(data.shipBuyerName,  pageWidth / 2 + 10, 106);    
    shippingLines.forEach((line, index) => {doc.text(line,  pageWidth / 2 + 10, 111 + index * 4); });// Adjust Y-coordinate for each line    
    

    
    const nextYCoordinateShip = 111 + shippingLines.length * 4;

    doc.text("Contact no : " + data.shipMobile, pageWidth / 2 + 10, nextYCoordinateShip);
    doc.text("Email ID : " + data.shipEmail, pageWidth / 2 + 10, nextYCoordinateShip + 4);



    // Product Details Section
    const startY = 140; // Y-coordinate where product table starts
    doc.setFontSize(10);
    doc.setFont("helvetica", "narmal");
    doc.text("Product Details", 10, startY);

    const productTableData = await Promise.all(
      dataProduct.map(async(product, index) => {
        let base64Image = null;
        let imagePosition = null;
        // Check if image exists, convert to Base64
        if (product.imageURL) {
          try {
            base64Image = await loadImageBase64(imagePath + product.imageURL);
            imagePosition = { x: 40, y: startY + 10 + index * 30 }; // Add x, y coordinates for image
          } catch (error) {
            console.error("Error loading image:", error);
          }
        }
      
  
        return [
          { content: (index + 1).toString(), styles: { halign: "center" } }, // Serial No.
          { content: product.productName || "N/A" }, // Product Title
          { content: "imageCell", styles: { halign: "center" } }, // Image
          { content: product.hsnCode.toString(), styles: { halign: "center" } }, // hsnCode
          { content: `${product.price.toFixed(2)}`, styles: { halign: "right" } }, // Price        
          { content: `${(product.sgst).toFixed(2)}`, styles: { halign: "right" } },
          { content: `${(product.cgst).toFixed(2)}`, styles: { halign: "right" } },
          { content: `${(product.igst).toFixed(2)}`, styles: { halign: "right" } },
          { content: `${(product.gstPrice).toFixed(2)}`, styles: { halign: "right" },
          }, // Total
        ];
      })
    );
  
      doc.autoTable({
        head: [["#", "Product Title", "Image", "hsn Code", "Price", "SGST", "CGST", "IGST", "Total"]],
        body: productTableData,
        startY: startY + 5,
        styles: { fontSize: 10 },
        columnStyles: {
          0: { cellWidth: 10 }, // Serial No.
          1: { cellWidth: 50 }, // Product Title
          2: { cellWidth: 30 }, // Image Placeholder
          3: { cellWidth: 20 }, // hsn
          4: { cellWidth: 20 }, // Price
          5: { cellWidth: 20 }, // SGST
          6: { cellWidth: 20 }, // CGST
          7: { cellWidth: 20 }, // IGST
          8: { cellWidth: 20 }, // GST PRICE
        },
      });

        // Add Images Manually After Table
        productTableData.forEach((product, index) => {
          if (product.imagePosition) {
            doc.addImage(product.base64Image, "jpeg", product.imagePosition.x, product.imagePosition.y, 30, 30); // Add Image at specific coordinates
          }
        });




    //Product Details Section Ends Here


    // Footer
    const finalY = doc.lastAutoTable.finalY || 140;
  doc.setFontSize(10);
  doc.text("Terms and Conditions:", 10, finalY + 10);
  doc.text("Return Policy: 7 days if ordered as unframed. Not applicable if ordered as Framed or in Custom Size, or if Delivery is outside India.", 10, finalY + 20);
  doc.text("No Exchange or Return unless received damaged.", 10, finalY + 30);
  doc.text("Bank Details", 10, finalY + 40);
  doc.text("IFSC: ICIC0001821", 10, finalY + 50);
  doc.text("Swift Code / BI: CHASDEFXXXX", 10, finalY + 60);
  doc.text("Mahavir Enclave, New Delhi, INDIA", 10, finalY + 70);

  // Save PDF
  doc.save("invoice.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("Failed to generate the invoice. Please try again.");
  }
};